// extracted by mini-css-extract-plugin
module.exports = {"name":"name--7iKUv"};